export default __webpack_public_path__ + "6b9514b37851e5cc11afdb39465db022.jpg";